import { useForm } from 'react-hook-form';

import { Headline } from 'components/Headline';
import { Table } from 'components/Table';
import { Button } from 'components/Button';

import { useColumns } from './columns.data';
import { Input } from './types';
import * as S from './Panel.styles';

type PanelProps = {
  title: string;
  inputs: Input[];
};

export function Panel(props: PanelProps): React.ReactElement {
  const { title, inputs } = { ...props };
  const { register } = useForm();
  const columns = useColumns(register);

  const inputsMapped = inputs?.map((input: Input) => (
    <S.InputWrapper key={input.name}>
      <S.PanelInput motive="m3" register={register} name={input.name} label={input.label} />
      {input.vatLabel ? (
        <S.InputLabel fontWeight="extraLight">(incl. VAT)</S.InputLabel>
      ) : null}
    </S.InputWrapper>
  ));

  return (
    <S.Container>
      {title ? (
        <S.Title tag="h4" scale="lg" fontWeight="light">
          {title}
        </S.Title>
      ) : null}

      {inputs ? <S.InputGroup>{inputsMapped}</S.InputGroup> : null}

      <S.Header>
        <Headline>Discounts for quantity</Headline>

        <Button iconLeft="FiPlus" motive="add" />
      </S.Header>

      <Table
        motive="m2"
        columns={columns}
        data={[
          {
            amount: '',
            discount: '',
          },
        ]}
      />
    </S.Container>
  );
}
